import * as React from 'react';

import moment from 'moment';

import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';
import {RelativeTimestamp} from 'shells/timestamp/relative-timestamp';

import {isToday} from 'nutshell-core/date-time';

type Props = {
    submissionTime: number;
};

export function FormSubmissionTimestamp(props: Props) {
    if (isToday(moment.unix(props.submissionTime))) {
        return (
            <div className='flex'>
                submitted&nbsp;
                <RelativeTimestamp datetime={props.submissionTime} />
            </div>
        );
    }

    return (
        <div className='flex'>
            submitted on&nbsp;
            <FormattedTimestamp
                datetime={props.submissionTime}
                format={FormattedTimestamp.formats.longMonthDayWithYear}
            />
        </div>
    );
}
